import lmslogo from './lms-school-logo.png'
import logo from './logo.jpg'
import losos from './losos.png'
import senya from './senya.png'

export default {
  lmslogo,
  logo,
  losos,
  senya,
}
